import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss']
})
export class FailedComponent implements OnInit {
  faDownload = faDownload
  constructor(
    private router: Router,
    private storageService: StorageService 
  ) { }

  ngOnInit(): void {
  }

  stepOn(){
    const token = this.storageService.getData('encodedToken');
    this.router.navigate(['/'], { queryParams: { q: token } })

  }
}
